<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dDKZV6/tc-custom/9780765396990.jpg?1731883501358" alt="This image is the cover for the book Hollow Empire, The Poison Wars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hollow Empire, The Poison Wars
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Moving from poison and treachery to war and witchcraft, Sam Hawke's Poison Wars continue with <i>Hollow Empire</i>, a fabulous epic fantasy adventure perfect for fans of Robin Hobb, Naomi Novik, and Scott Lynch.</b><br/><br/>Poison was only the beginning.... The deadly siege of Silasta woke the ancient spirits, and now the city-state must find its place in this new world of magic.  But people and politics are always treacherous, and it will take all of Jovan and Kalina’s skills as proofer and spy to save their country when witches and assassins turn their sights to domination.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Hawke
      </h2>
      
      <p class="authorDescription body article">A black belt in jujitsu, SAM HAWKE lives in Australia with her husband and children. <I>City of Lies</I> was her first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e1b1560